<template>
  <section class="page-container">
    <template v-if="!isReferralRequest">
      <!-- <h1>Select Plan</h1> -->
      <h1>{{getOptionName('classOptions', quoteForm.class_id)}}</h1>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <div class="abs-top-right flex">
          <v-button
            v-if="!isFina"
            gray
            @click="handlerCreateAccount">Create Account</v-button>
          <el-form-item
            v-if="isFina"
            ref="referrer_id"
            :rules="rules.select"
            class="mg-r-10"
            prop="referrer_id" >
            <v-button
              gray
              icon="user-tie"
              class="mg-r-10"
              @click="handlerSelect(2)">{{btn_refer_text}}</v-button>
          </el-form-item>
          <v-button
            v-else
            gray
            icon="user-circle"
            @click="handlerSelect(1)">{{btn_text}}
          </v-button>
          <!-- 已经void的才显示 -->
          <v-button
            v-if="quoteForm.pcy_stts == 0"
            gray
            @click="addReferCase">Add Refer Case</v-button>

          <v-button
            gray
            @click="() => $router.back()">Back</v-button>
        </div>
      </el-form>
    </template>
    <template v-else>
      <h1>Select Plan</h1>
      <div class="abs-top-right">
        <v-button @click="$emit('back')">Back</v-button>
      </div>
    </template>
    <div class="warning">
      <block-warning
        v-if="block_data.length>0"
        class="mg-b-15"
        :customerProfile="customer_profile"></block-warning>
    </div>

    <div
      v-if="false"
      class="info-container">
      <housemaid-quick-quote-info
        v-if="productId == 12"
        :quoteForm="quoteForm"/>
      <!--      <working-quick-quote-info-->
      <!--        v-else-if="productId == 13"-->
      <!--        :quoteForm="quoteForm"/>-->
      <div  v-else-if="productId == 13"></div>
      <travel-quick-quote-info
        v-else-if="productId == 14"
        :quoteForm="quoteForm"/>
      <decoration-quick-quote-info
        v-else-if="productId == 15"
        :quoteForm="quoteForm"/>
      <student-quick-quote-info
        v-else-if="productId == 16"
        :quoteForm="quoteForm"/>
      <personal-quick-quote-info
        v-else-if="productId == 18"
        :quoteForm="quoteForm"/>
      <homefire-quick-quote-info
        v-else-if="productId == 17||productId==20"
        :quoteForm="quoteForm"/>
      <motor-quick-quote-info
        v-else
        :quoteForm="quoteForm"/>
    </div>
    <div class="main-container">
      <div class="left">
        <quoteFilterInfo
          v-if="productId!=13"
          :classId="classId"
          :localAllOptions="localAllOptions"
          :isShowPcyCmntDt="isShowPcyCmntDt"
          :isElectricCar11="isElectricCar11"
          v-on="$listeners"
        />
        <template  v-if="productId==11 && ![14,15].includes(classId)" >
          <div class="card-item">
            <div class="item">
              <div class="left">NCD</div>
              <div class="right">
                <v-radio-group
                  v-model="filterData.ncd_pct"
                  button
                  :list="ncdList"
                  @change="handler().getUpdateAllQuote(0)" />
              </div>
            </div>
            <div class="item">
              <div class="left">Coverage</div>
              <div class="right">
                <v-radio-group
                  v-model="filterData.trm_of_cvr"
                  button
                  :list="coverageList"
                  @change="handleFilterTrm" />
              </div>
            </div>
            <div
              v-show="filterData.trm_of_cvr==2"
              class="item">
              <div class="left">Sum Insured</div>
              <div class="right">
                <v-input
                  v-model="filterData.isrd_vl"
                  prepend="HK$"
                  @blur="handler().getUpdateAllQuote(0)" />
              </div>
            </div>
          </div>
        </template>
        <div class="card-item">
          <code-select
            :customerId="customerId"
            :product="productId"
            :classId="quoteForm.class_id"
            :notApply="true"
            :customer="customer"
            :is-small="true"
            :is-fina="isFina"
            isUser
            @check-code="handlerGetAllQuote"
          ></code-select>
          <div
            v-if="showReferralSelect&&!isFina"
            class="flex">
            <v-select
              v-model="referral_id"
              :list="referral_option_list"
              @change="handler().getUpdateAllQuote(0)"></v-select>
            <v-button
              gray
              class="mg-l-10"
              @click="handleInitRefer">Default</v-button>
          </div>
          <div class="item mg-t-15">
            <div class="left">
              Sorting
            </div>
            <div class="right">
              <quoteSorting
                v-model="filterData.order_by"
                class="order_select"
                :list="sortOptions"
                @change="handler().getUpdateAllQuote(0)"
              >
              </quoteSorting>
            </div>
          </div>
          <div class="item">
            <div class="left">Share</div>
            <div class="flex-inline">
              <div>
                <popover @selectLang="getLang">
                  <v-button
                    gray
                    icon="sms"
                    @click="handleShare(1)">SMS
                  </v-button>
                </popover>
              </div>
              <div>
                <popover @selectLang="getLang">
                  <v-button
                    gray
                    icon="envelope"
                    @click="handleShare(3)">Email
                  </v-button>
                </popover>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="coverageOptions.length > 0"
          class="card-item">
          <div class="form-item">
            <span>Cover Type</span>
            <v-radio-group
              v-model="filterData.coverage_id"
              :block="true"
              :wrap="true"
              :list="coverageOptions"
              @change="coverageChange"/>
          </div>
          <div
            v-if="productId==20||productId==17&&filterData.coverage_id==3"
            class="form-item">
            <span>Sum Insured of Building Structure</span>
            <v-input
              v-model="bsc_sum_insured"
              prepend="HK$"
              @keyEnter="handler().getUpdateAllQuote(0)"
              @blur="handler().getUpdateAllQuote(0)" />
          </div>
        </div>
        <div
          v-if="classId==11&&extrabenefitsList.length>0&&!isFina"
          class="card-item">
          <div class="form-item">
            <span class="flex flex-sb">
              <span>Extra Benefits</span>
              <span
                class="unreset-color"
                @click="handlerReset('extra_benefits')">Reset</span>
            </span>
            <v-checkbox-group
              v-model="filterData.extra_benefits"
              :list="extrabenefitsList"
              @change="handler().getUpdateAllQuote(0)"/>
          </div>
        </div>
        <div
          v-if="showPlanLevel"
          class="card-item">
          <div class="form-item">
            <span class="flex flex-sb">
              <span>Plan Level</span>
            </span>
            <v-radio-group
              v-model="filterData.plan_tier"
              :block="true"
              :wrap="true"
              :list="planLevelOptions"
              @change="handler().getUpdateAllQuote(0)"
            />
          </div>
        </div>
        <div
          v-if="showBenefitsTab"
          class="card-item">
          <div class="form-item">
            <span class="flex flex-sb">
              <span>More Benefits</span>
              <span
                class="unreset-color"
                @click="handlerReset('benefits')">Reset</span>
            </span>
            <v-checkbox-group
              v-model="filterData.benefits"
              :list="benefitsList"
              @change="handler().getUpdateAllQuote(0)"/>
          </div>
        </div>
        <div class="card-item">
          <div class="form-item">
            <!--            <span>Company</span>-->
            <span class="flex flex-sb">
              <span>Company</span>
              <span
                class="unreset-color"
                @click="handlerReset('company')">Reset</span>
            </span>
            <v-checkbox-group
              v-model="filterData.company"
              :isColumn="false"
              :list="quoteResult.filter_company"
              @change="handler().getUpdateAllQuote(0)"/>
          </div>
        </div>
      </div>
      <div class="main-content mg-t-20">
        <quote-plan-list
          :allQuoteList="allQuoteList"
          :quoteDetailData="quoteResult.detail"
          :shortlist="quoteResult.shortlist"
          :detail_b="quoteResult.detail_b"
          :list_b="quoteResult.list_b"
          :classId="quoteForm.class_id"
          :haveReferenceQuote="true"
          @buy-policy="handlerBuyPolicy"
          @share-one-plan="handleShareOnePlan"
          @share-lang="handleShareLang"
          @get-reference-quote="handlerGetReferenceQuote" />
      </div>
    </div>

    <buy-policy-tips
      ref="buy-policy-tips"
      :classId="quoteForm.class_id"
      :underList="underList"
      :is-copy="isCopy"
      :showUnderList="showUnderList"
      @confirm="confirmBuyPolicy"/>

    <contact-dialog
      ref="contact-dialog"
      :initCustomerId="customerId"
      :shareLink="shareLink"
      :customerData="isFina?selectReferCustomerData:selectCustomerData"
      :isInput="isInput"
      :is-fina="isFina"
      has-type
      :type="contactType"/>
    <attach-customer
      ref="attachCustomer"
      :customer-type="customer_type"
      :is-personal="isHzmb"
      :commercial-customer-type="quoteForm.cust_typ"
      @handlerSelectCustomer="handleSelectCustomer"></attach-customer>
    <share-guest-attach-customer
      ref="shareGuestCustomer"
      isShare
      :orderId="orderId"></share-guest-attach-customer>
    <create-account-dialog
      v-model="createAccountDialog"
      :commercial-customer-type="quoteForm.cust_typ"
      :is-personal="isHzmb"
      :is-commercial="isCommercial"
      :product-type="productId"></create-account-dialog>
  </section>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinCreateAccount from '@/mixins/create-account'
import MixinFormat from '@/mixins/format'
import MixinFina from '@/mixins/fina'
import MixinRules from '@/mixins/rules'
import BuyPolicyTips from './dialogs/buy-policy-tips'
import {getQuoteAll, getQuoteAllNew, getQuoteReference, getQuoteShare, saveQuotation} from '@/api/quote'
import {selectShareGuestQuote} from '@/api/share'
import QuotePlanList from './components/quote-plan-list'
import CodeSelect from '@/views/components/code-select'
import ContactDialog from '@/views/tickets/dialogs/contact-dialog'
import MotorQuickQuoteInfo from './modules/motor/quick-quote-info'
import HousemaidQuickQuoteInfo from './modules/housemaid/quick-quote-info'
import StudentQuickQuoteInfo from './modules/student/quick-quote-info'
import PersonalQuickQuoteInfo from './modules/personal/quick-quote-info'
import TravelQuickQuoteInfo from './modules/travel/quick-quote-info'
import DecorationQuickQuoteInfo from './modules/decoration/quick-quote-info'
import HomefireQuickQuoteInfo from './modules/homefire/quick-quote-info'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import quoteSorting from './components/quote-sorting'
import {downloadFile} from '@/utils/download'
import shareGuestAttachCustomer from '@/views/records/quote/components/dialog/attachCustomer'
import popover from '@/views/quoting/components/popover'
import BlockWarning from '@/views/components/block-warning'
import {getAccountDetail} from '@api/account'
import quoteFilterInfo from './components/quote-filter-info'
import MixinReferralOption from '@/mixins/referral-option'

export default {
  name: 'Quote',
  components: {
    BuyPolicyTips,
    QuotePlanList,
    // PromoCode,
    ContactDialog,
    MotorQuickQuoteInfo,
    HousemaidQuickQuoteInfo,
    StudentQuickQuoteInfo,
    TravelQuickQuoteInfo,
    DecorationQuickQuoteInfo,
    HomefireQuickQuoteInfo,
    attachCustomer,
    CodeSelect,
    PersonalQuickQuoteInfo,
    shareGuestAttachCustomer,
    quoteSorting,
    popover,
    BlockWarning,
    quoteFilterInfo
  },
  mixins: [MixinOptions, MixinFormat,MixinReferralOption,MixinFina,MixinRules,MixinCreateAccount],
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    referralRequestId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      customer_type:2,
      formData:{
        referrer_id:''
      },
      customer_profile:{},
      isCode:false,
      isNewQuote:true,
      isInput:true,
      insuranceTypeOptions: [
        {
          name: 'Third party liability insurance increased to three million',
          id: 1
        },
        {
          name: 'Attached to the car itself in Guangdong Province',
          id: 2
        },
        {
          name: 'Attached to the car itself in Guangdong Province',
          id: 3
        },
        {
          name: 'Hong Kong-Zhuhai-Macao Bridge Auto Insurance',
          id: 4
        }
      ],
      buyIndex: -1, // 標記報價索引
      filterData: {
        benefits: [],
        extra_benefits: [],
        company: [],
        order_by: 'hcr_cheapest',
        isrd_vl: '',  //  車保用這個
        tol_contr_sum: '',  //  Interior Decoration 用這個
        trm_of_cvr: '',
        coverage_id: '',
        plan_tier: 0,
        ncd_pct: 0
      },
      bsc_sum_insured:'',
      contactType: 1, // 1 - SMS, 3 - Email
      shareLink:'',
      lang: 1,  //1 - en, 0 - zh
      coverageList:[
        // {
        //   id: 0,
        //   name: 'All'
        // },
        {
          id: 1,
          name: 'TPO' //第三方
        },
        {
          id: 2,
          name: 'Comp.' //全面
        },
      ],
      share_uniq_plan:{},
    }
  },
  computed: {
    ...mapState('coupon', ['selectCode']),
    ...mapState('common', ['productId']),
    ...mapState('quote', ['allQuote', 'quoteForm', 'copyQuoteForm', 'carModelOptions', 'quoteResult', 'code']),
    ...mapState('account', ['customerId', 'selectCustomerData', 'referCustomerId', 'selectReferCustomerData']),
    isCommercial() {
      let {product_id, class_id} = this.quoteForm || {}
      return this.productId == 11 && class_id == 12
    },
    isHzmb(){
      let {class_id} = this.quoteForm||{}
      return class_id==15
    },
    isCopy() {
      let {copy} = this.quoteForm || {}
      return copy == 1
    },
    form() {
      return {...this.filterData, ...this.quoteForm}
    },
    block_data() {
      let {block_data = []} = this.customer_profile || {}
      return block_data
    },
    orderId(){
      return this.$route.query.order_id
    },
    isShowPlanLevel(){
      if(this.productId == 12){
        const { coverage_id } = this.filterData
        return coverage_id == 1 ? false : true
      }else{
        return false
      }
    },
    showUnderList(){
      let arr = this.allQuoteList||[]
      let obj = arr[this.buyIndex]||{}
      let {mixin_underwriting} = obj||{}
      let arrList = mixin_underwriting||[]
      return  arrList.filter(item=>item.type=='clause')||[]
    },
    underList(){
      let arr = this.allQuoteList||[]
      let obj = arr[this.buyIndex]||{}
      let {underwriting} = obj||{}
      return  underwriting||[]
    },
    classId() {
      const id = this.quoteForm.class_id || 14
      return Number(id)
    },
    sortOptions(){
      let options = this.localAllOptions.sorting_all
      const trm_of_cvr = this.filterData.trm_of_cvr
      // let trm_of_cvr = ''
      // if(trmArr.length == 1){
      //   trm_of_cvr = trmArr[0]
      // }else if(trmArr.length > 1){
      //   trm_of_cvr = 0
      // }
      if(Array.isArray(options)){
        return options
      }else if(Object.prototype.toString.call(options) === '[object Object]'){
        switch (trm_of_cvr) {
          case 0:
            return options.all || []
          case 1:
            return options.tpo || []
          case 2:
            return options.comp || []
          default:
            return []
        }
      }else{
        return []
      }
    },
    localAllOptions() {
      const classId = this.quoteForm.class_id || 14
      if (classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${classId}`]
      }
    },
    isPartTime() {
      const { nature } = this.quoteForm
      return nature === 2
    },
    coverageOptions() {
      const  coverage = this.localAllOptions.coverage || []
      if(this.isPartTime) {
        return coverage.filter(item => item.part_time === 1)
      }
      if(this.isDriver) {
        return coverage.filter(item => item.id === 2)
      }
      return coverage
    },
    allQuoteList() {
      return this.allQuote
      // const classId = this.quoteForm.class_id || 14
      // if (classId === 14) return []
      // return this[`allOptions${classId}`].benefits || []
      // const benefits = this.quoteForm.benefits
      // return this[`allOptions${classId}`].benefits.filter(item => {
      //   return benefits.includes(item.id)
      // })
    },
    insuranceType() {
      if (this.quoteForm.class_id == 14) {
        return this.coverTypeOptions.filter(item => {
          return item.id !== 2 // 電單車沒有全保
        })
      }
      return this.coverTypeOptions
    },
    benefitsList() {
      // const {benefits = []} = this.quoteForm
      // if (!benefits) {
      //   return []
      // }
      // return benefits.reduce((result, item) => {
      //   result.push(
      //     this.getAllOptionName26('benefits', item)
      //   )
      //   return result
      // }, [])
      // const classId = this.quoteForm.class_id || 14
      // if (classId === 14) return []
      // return this[`allOptions${classId}`].benefits || []

      let benefits = this.localAllOptions.benefits || []
      if(this.isDoula || (this.filterData.coverage_id == 1 && this.productId == 12)) {
        benefits = benefits.filter(item => item.id != 1)
      }
      if(this.classId == 12){
        let tl_list = [32, 64]
        let cr_list = [128, 256]
        let data = this.getOptionData('', this.quoteForm.typ_of_bdy_mix_id, this.allOptions12.typ_of_mix)
        let {cr_enable,tl_enable} = data||{}
        if(!tl_enable){
          benefits = benefits.filter((item) => !tl_list.includes(item.id))
        }
        if(!cr_enable){
          benefits = benefits.filter((item) => !cr_list.includes(item.id))
        }
      }
      return benefits
    },
    group_name(){
      let benefitObj  = this.benefitsList.reduce((result, item)=>{
        if(item.is_group==1){
          result[item.group_name] = []
        }
        return result
      },{})
      return benefitObj
    },
    benefitsGroup(){
      let obj = this.group_name
      this.benefitsList.some((item)=>{
        if(item.is_group==1){
          obj[item.group_name].push(item.id)
        }
      })
      return obj
    },
    extrabenefitsList() {
      let benefits = this.localAllOptions.extra_benefits || []
      benefits = benefits.filter(item=>item.is_enabled==1)
      return benefits||[]
    },
    // show
    isDriver() {
      if(this.productId != 12) return false
      const { duty_id } = this.quoteForm
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { is_driver } = data || {}
      return !!is_driver
    },
    isDoula() {
      if(this.productId != 12) {
        return false
      }
      const { duty_id } = this.quoteForm
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    isCoverageFire() {
      const { coverage_id } = this.filterData
      const data = this.getOptionData('', coverage_id, this.localAllOptions.coverage)
      const { id } = data || {}
      return id == 2
    },
    showBenefitsTab() {
      if(this.benefitsList.length == 0) {
        return false
      }
      if(this.productId == 17||this.productId==20) {
        return !this.isCoverageFire
      }
      return true
    },
    showPlanLevel(){
      return [12,17,14,16,13,18].includes(Number(this.productId))
    },
    customer(){
      return this.selectCustomerData||{}
    },
    ncdList(){
      let class_id = this.classId
      let arr = []
      switch(class_id){
        case 11:
          arr = JSON.parse(JSON.stringify(this.allOptions11.ncd))
          break
        case 14:
          arr = JSON.parse(JSON.stringify(this.allOptions.ncd))
          break
        case 12:
          arr = JSON.parse(JSON.stringify(this.allOptions12.ncd))
          break
      }
      arr.map(item => {
        item.name = item.name.replace('%', '')
      })
      return arr
    },
    isShowPcyCmntDt(){
      const { plan_type } =  this.quoteForm
      if(this.classId == 23){
        return plan_type == 2 ? false : true
      }
      return true
    },
    isElectricCar11() {
      // 電動車，避免跟之前特斯拉脫機衝突
      const { model_id } = this.quoteForm
      if(model_id) {
        const data = this.getOptionData('', model_id, this.carModelOptions)
        const { is_electric_car } = data || {}
        return is_electric_car == 1
      }
      return false
    },
    isTL() {
      let {typ_of_bdy_mix_id} = this.quoteForm || {}
      return [9,8,10].includes(typ_of_bdy_mix_id)
    },
    isCR(){
      let {typ_of_bdy_mix_id} = this.quoteForm || {}
      return [7].includes(typ_of_bdy_mix_id)
    }
  },
  watch: {
    showBenefitsTab: {
      immediate: true,
      handler(val) {
        if(!val) {
          this.filterData.benefits = []
        }
      }
    },
    'filterData.benefits': {
      deep: true,
      handler(val, old) {
        if([11, 12].includes(this.classId)) {
          let benefitsGroup
          if( this.classId == 11){
            benefitsGroup = {
              group_11:[256, 512]
            }
          }else {
            benefitsGroup  = this.benefitsGroup
          }
          // 新增才需要考慮
          if(val.length > old.length) {
            // 判斷有多少個是衝突的
            Object.keys(benefitsGroup).some(key=>{
              let arr = benefitsGroup[key]
              const filterList = val.filter(item => arr.includes(item))
              if(filterList.length > 1) {
                let flag = false
                const result = val.reduce((result, item) => {
                  if(arr.includes(item) && !flag) {
                    flag = true
                    return result
                  }
                  result.push(item)
                  return result
                }, [])
                this.filterData.benefits = JSON.parse(JSON.stringify(result))
              }
            })
          }
        }
      }
    },
    'filterData.company': {
      deep: true,
      handler(val){
        if(val.length > 0 && this.filterData.order_by == 'hcr_cheapest'){
          this.filterData.order_by = 'price_cheapest'
          this.handler().getUpdateAllQuote(0)
        }
      }
    },
    'filterData.order_by':{
      deep: true,
      handler(val){
        if(val == 'hcr_cheapest' && this.filterData.company.length > 0){
          this.filterData.company = []
          this.handler().getUpdateAllQuote(0)
        }
      }
    },
    customerId:{
      immediate:true,
      handler(val){
        if(val){
          this.$nextTick(()=>{
            this.network().getAccountDetail({customer_id:val})
          })
        }
      }
    },
    referCustomerId:{
      immediate:true,
      handler(val){
        if(val){
          this.formData.referrer_id = val
          this.initFilter()
          this.$nextTick(()=>{
            this.$refs['form'].clearValidate(['referrer_id'])
          })
          this.handler().getUpdateAllQuote(0)
        }
      }
    }
  },
  created() {
    if (this.quoteForm.class_id && this.quoteForm.brand_id) {

      // 獲取 car model 數據
      this.updateCarModelOptions({
        val: this.quoteForm.brand_id,
        time: new Date().getTime()
      })
    }

    this.initFilter()

  },
  methods: {
    ...mapActions('quote', ['updateCarModelOptions', 'setAllQuote', 'setQuoteForm', 'setQuoteResult','setCode']),
    ...mapActions('coupon', ['setSelectCode', 'setCouponData','setReferrerData']),
    ...mapActions('account', ['setSelectCustomerData']),
    initFilter(){
      // 左邊篩選欄賦值
      if(this.quoteForm.hasOwnProperty('plan_tier')){
        this.$set(this.filterData, 'plan_tier', this.quoteForm.plan_tier)
      }
      Object.keys(this.filterData).some(key => {
        if (key in this.quoteForm) {
          // if (key == 'trm_of_cvr') {
          //   if(this.quoteForm[key]===0)
          //     this.filterData[key] =[1,2]
          //   else
          //     this.filterData[key].push(this.quoteForm[key])
          // }
          // else {
          this.filterData[key] = this.quoteForm[key]
          // }
        }
        else if(key == 'company') {
          if(this.quoteForm[key]) {
            this.filterData[key] = this.quoteForm[key]
          }
          // else {
          //   this.filterData[key] = this.localAllOptions.quote_company.reduce((result, item) => {
          //     result.push(item.id)
          //     return result
          //   }, [])
          // }

        }
      })
      if(this.productId==20){
        this.filterData.coverage_id = 2
        this.bsc_sum_insured  = this.quoteForm.bsc_sum_insured
      }
      if(this.productId==17&&this.filterData.coverage_id==3){
        this.bsc_sum_insured  = this.quoteForm.bsc_sum_insured
      }
      if(this.classId==11){
        this.handlerExtraData()
      }
      let {code={}} = this.selectCode||{}
      // if(!this.isFina)
      //   this.mixinNetwork().getOrderReferralList({code:code.code})
      if(this.classId==11){
        if(this.isTL){
          this.filterData.benefits = Array.from(new Set([64,...this.filterData.benefits]))
        }
        if(this.isCR){
          this.filterData.benefits = Array.from(new Set([256,...this.filterData.benefits]))
        }
      }
    },
    async  handleSelectCustomer(){
      if(this.buyIndex<0)
        return
      if(!this.orderId && this.productId==16){
        this.handlerKYC()
      }else
      {
        setTimeout(()=>{
          this.$refs['buy-policy-tips'].changeDialog()
        },500)
      }
    },
    async handleFilterTrm(){
      let {trm_of_cvr} = this.filterData
      let {code={},is_campaign_code} = this.selectCode||{}
      const { plan_type } =  this.quoteForm
      this.setReferrerData(null)
      let params ={
        class_id:this.classId,
        code:code.code
      }
      if(is_campaign_code==1){
        params.campaign_code = code.code
      }
      params.plan_type = plan_type
      // await this.mixinNetwork().getOrderReferralList({trm_of_cvr,...params})
      this.handleUpdate()
    },
    handleShareOnePlan(type,params){
      this.contactType = type
      this.share_uniq_plan = params
    },
    handleShare(type){
      this.contactType = type
      this.share_uniq_plan = {}
    },
    handleInitRefer(){
      this.initReferrerId()
      this.handler().getUpdateAllQuote(0)
    },
    handleUpdate(){
      let {class_id,model_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr} = this.quoteForm||{}
      if(class_id==11)
      {
        let {trm_of_cvr} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,rgtn_yr,enough_age_ind,enough_exp_ind})
      }
      this.handler().getUpdateAllQuote(0)
    },
    coverageChange(val){
      if(this.productId == 12 && val == 1){
        this.filterData.plan_tier = 1
      }
      this.handler().getUpdateAllQuote(0)
    },
    changeInsurance(){
      this.filterData.order_by = ''
      this.handler().getUpdateAllQuote(0)
      this.handlerExtraData()
    },
    handlerExtraData(){
      let {class_id,model_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr} = this.quoteForm||{}
      if(class_id==11)
      {
        let {trm_of_cvr} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,rgtn_yr,class_id,model_id,nm_drvr_list,enough_age_ind,enough_exp_ind})
      }
    },
    handlerReset(name){
      this.filterData[name] = []
      this.handlerGetAllQuote()
    },
    handlerSelect(type) {
      this.buyIndex = -1
      if(this.orderId){
        this.$refs.shareGuestCustomer.changeDialog()
      }else{
        this.customer_type = type
        this.$refs.attachCustomer.showAttachCustomer()
      }
    },
    handlerBuyPolicy(index) {
      this.buyIndex = index
      if(this.isFina&&!this.referCustomerId)
      {
        this.customer_type = 2
        this.buyIndex = -1
        this.$refs.attachCustomer.showAttachCustomer()
        return
      }
      if(!this.isFina&&!this.customerId)
      {
        this.customer_type = 1
        this.$refs.attachCustomer.showAttachCustomer()
        return
      }

      if(!this.orderId && this.productId==16){
        this.handlerKYC()
      }else
        this.$refs['buy-policy-tips'].changeDialog()
      // this.$refs.form.validate(valid => {
      //   if(valid) {
      //     this.buyIndex = index
      //     if(!this.orderId && this.productId==16){
      //       this.handlerKYC()
      //     }else
      //       this.$refs['buy-policy-tips'].changeDialog()
      //   }
      // })
    },
    handlerKYC(){
      const {company_id, trm_of_cvr, plan_id} = this.quoteResult.list[this.buyIndex].plan_info
      const benefits = this.filterData.benefits || []
      const extra_benefits = this.filterData.extra_benefits || []
      const data = {
        ...this.quoteForm,
        company_id,
        trm_of_cvr,
        plan_id, // 家佣 housemaid
        benefits,
        extra_benefits,
        // part_of_under_cond: 0
        underwriting_confirm: 1,
        ...this.code_discount_info
      }
      if(this.classId==11){
        data.extra_benefits = [8, 16, ...extra_benefits]
      }
      if (!this.customerId&&!this.isFina) {
        const {trm_of_cvr = [], isrd_vl} = this.filterData
        this.$router.push({
          name: 'quotingCustomer',
          query: {
            filterData:isrd_vl,
            product_id: this.productId,
            data:JSON.stringify(data)
          }
        })
        return
      }
      // 調取保存報價接口
      this.network().saveQuotation(data)
    },
    handlerGetReferenceQuote(index, url) {
      const {company_id, trm_of_cvr, plan_id,} = this.quoteResult.list[index].plan_info
      const benefits = this.filterData.benefits || []
      let {isrd_vl} = this.filterData
      const extra_benefits = this.filterData.extra_benefits || []

      const data = {
        ...this.quoteForm,
        company_id,
        trm_of_cvr,
        plan_id, // 家佣 housemaid
        benefits,
        extra_benefits,
        isrd_vl,
        underwriting_confirm: 1,
        referrer_id:this.formData.referrer_id,
        merchant_platform:this.isFina?2:1
      }

      this.network().getQuoteReference(url,data)
    },
    getLang(lang){
      this.lang = lang == 'en'? 1 : 0
      this.network().getQuoteShare()
    },
    handleShareLang(lang){
      this.lang = lang
      this.network().getQuoteShare()
    },
    onSendDialog(type) {
      this.contactType = type
      // if (!this.customerId) {
      //   return  this.$message({
      //     type: 'warning',
      //     message: '請先選擇用戶'
      //   })
      // }
      this.network().getQuoteShare()
    },
    confirmBuyPolicy(underwriting,cust_typ) {
      if(this.classId==11){
        const params = JSON.parse(JSON.stringify(this.quoteForm))
        let {extra_benefits=[]} = this.filterData||{}
        if(!this.isFina)
          params.extra_benefits = Array.from(new Set([8,16,...extra_benefits]))
        params.merchant_platform = 1
        if(this.isFina){
          params.cust_typ = cust_typ
          params.merchant_platform = 2
        }
        this.setQuoteForm(params)
      }
      if (underwriting) {
        // 存在則去 refer 頁
        // 更新一下 quote form 數據
        const params = JSON.parse(JSON.stringify(this.quoteForm))
        params.underwriting = underwriting
        params.merchant_platform = 1
        if(this.isFina){
          params.cust_typ = cust_typ
          params.merchant_platform = 2
        }
        this.setQuoteForm(params)

        if(this.isReferralRequest) {
          this.$emit('refer')
          return
        }

        this.$router.push({
          path: '/quoting/refer',
          query: {
            product_id: this.productId,
            from: 'part'
          }
        })
      } else {
        const {company_id, trm_of_cvr, plan_id,} = this.quoteResult.list[this.buyIndex].plan_info
        const benefits = this.filterData.benefits || []
        const extra_benefits = this.filterData.extra_benefits || []
        let data = {}
        data = {
          company_id,
          benefits,
          plan_id,
          merchant_platform:this.isFina?2:1
        }
        if(this.isFina){
          data = {
            ...data,
            cust_typ:cust_typ
          }
        }
        if(this.orderId){
          let {selectCode,coupon={},code={},is_campaign_code,campaign_code} = this.selectCode||{}
          let params = {}
          params.coupon_code = coupon&&coupon.coupon_code
          params.code =code&&code.code
          if(is_campaign_code==1){
            params.campaign_code =  coupon&&coupon.coupon_code
            params.coupon_code = ''
          }
          data = {
            order_id: this.orderId,
            ...data,
            ...params,
          }
        }else{
          data = {
            ...this.quoteForm,
            trm_of_cvr,
            ...data,
            underwriting_confirm: 1,
          }
        }
        if(!this.isFina)
          data.extra_benefits = this.classId==11?Array.from(new Set([8,16,...extra_benefits])):extra_benefits
        if (!this.customerId&&!this.isFina) {
          const {trm_of_cvr = [], isrd_vl} = this.filterData
          this.$router.push({
            name: 'quotingCustomer',
            query: {
              filterData:isrd_vl,
              product_id: this.productId,
              data:JSON.stringify(data),
              order_id: this.orderId,
            }
          })
          return
        }
        // 調取保存報價接口
        if(this.orderId){
          this.network().selectShareGuestQuote(data)
        }else{
          this.network().saveQuotation(data)
        }
      }

    },
    async handlerGetAllQuote() {
      if(this.isFina)return
      let {selectCode,coupon={},code={},is_campaign_code,campaign_code} = this.selectCode||{}
      const { plan_type } =  this.quoteForm

      let params ={
        class_id:this.classId,
        code:code.code
      }
      if(is_campaign_code==1){
        params.campaign_code = coupon.coupon_code
      }
      params.plan_type = plan_type
      // this.mixinNetwork().getPromoPreselect(params)
      // await this.mixinNetwork().getOrderReferralList(params)
      this.network().getQuoteAllNew()

    },
    handler() {
      return {
        getUpdateAllQuote: () => {
          // 這裏要區分產品
          this.network().getQuoteAllNew()
        }
      }
    },
    addReferCase(){
      this.$router.push({
        path:`/quoting/${this.severType}/refer`,
        query: {
          product_id: this.productId
        }
      })
    },
    network() {
      return {
        saveQuotation: async (params) => {
          const {trm_of_cvr = [], isrd_vl} = this.filterData
          params.isrd_vl = isrd_vl
          params.ref_agency_id = 0
          let {coupon={},code={},is_campaign_code} = this.selectCode||{}
          params.coupon_code = coupon&&coupon.coupon_code
          if(is_campaign_code==1){
            params.campaign_code =  coupon&&coupon.coupon_code
            params.coupon_code = ''
          }
          if(this.isReferralRequest&&!this.isFina) {
            params.referral_request_id = this.referralRequestId
          }
          if(!this.isFina)
          {
            params.code = code&&code.code
            params = {
              ...params,
              ...this.code_discount_info
            }
          }
          params.merchant_platform = 1
          if(this.isFina){
            params.referrer_id=this.referCustomerId
            params.merchant_platform = 2
          }
          const {data} = await saveQuotation({
            ...this.copyQuoteForm,
            ...params,
            customer_id: this.customerId||0,
          })

          if(data.code == 4179){
            this.$router.push({
              name: 'quotingRefer',
              query: {
                product_id: this.productId
              }
            })
            return
          }
          // this.setCode(this.code)
          const {order_id, quo_id} = data.data

          if(this.isReferralRequest) {
            this.$emit('success', {
              order_id,
              quo_id,
              product_id: this.productId
            })
            return
          }
          let {copy} = this.quoteForm||{}
          let query = {
            order_id,
            quo_id,
            product_id: this.productId,
            copy
          }
          if(this.isFina&&params.cust_typ){
            query.cust_typ=params.cust_typ
          }
          this.$router.push({
            path: '/quoting/information',
            query: query
          })
        },
        selectShareGuestQuote: async (params) => {
          let {selectCode,coupon={},code={},is_campaign_code} = this.selectCode||{}
          params.coupon_code = coupon&&coupon.coupon_code
          // params.code =code&&code.code
          if(is_campaign_code==1){
            params.campaign_code =  coupon&&coupon.coupon_code
            params.coupon_code = ''
          }
          const { data } = await selectShareGuestQuote(params)
          const {order_id, quo_id} = data.data
          let query = {
            order_id,
            quo_id,
            product_id: this.productId,
          }
          // if(this.isFina&&params.cust_typ){
          //   query.cust_typ=params.cust_typ
          // }
          this.$router.push({
            path: '/quoting/information',
            query: query
          })
        },
        getQuoteShare: async () => {
          let codeData = ''
          const benefits = this.filterData.benefits || []
          let {extra_benefits=[],trm_of_cvr,isrd_vl} = this.filterData ||{}
          let { code={}} = this.selectCode||{}
          codeData =code&&code.code

          let coupon_code = this.selectCode && this.selectCode.coupon? this.selectCode.coupon.coupon_code : ''
          let params ={
            ...this.quoteForm,
            customer_id: this.customerId||0,
            code: codeData,
            product_id:this.productId,
            benefits,
            coupon_code,
            trm_of_cvr,
            extra_benefits,
            is_en: this.lang,
            merchant_platform:this.isFina?2:1,
            ...this.share_uniq_plan
          }
          if(trm_of_cvr==2){
            params.isrd_vl = isrd_vl
          }
          const {data} = await getQuoteShare(params)
          const {share_link} = data
          this.shareLink = share_link
          if(this.showReferralSelect){
            this.$ConfirmBox({
              isNewConfirm:true,
              width:500,
              title:'Share Quote Result',
              confirmBtn:'Continue',
              isGreen:true,
              message: 'This sharing can only use the referrer’s preset discount. Continue?'
            }).then(()=>{
              this.$refs['contact-dialog'].changeDialog()
            })
          }else {
            this.$refs['contact-dialog'].changeDialog()
          }

        },
        getQuoteAll: async (params = {}) => {
          const {trm_of_cvr, isrd_vl} = this.filterData
          if (trm_of_cvr == 2 && !isrd_vl) {
            this.$message({
              type: 'warning',
              message: '請填寫投保額'
            })
            return
          }

          let {coupon={},code={},is_campaign_code} = this.selectCode||{}
          params.coupon_code = coupon&&coupon.coupon_code
          if(!this.isFina){
            params.code =code&&code.code
          }
          if(is_campaign_code==1){
            params.campaign_code =  coupon&&coupon.coupon_code
            params.coupon_code = ''
          }
          const {data} = await getQuoteAll({
            ...this.quoteForm,
            ...this.filterData,
            merchant_platform:this.isFina?2:1,
            ...params
          })
          this.setAllQuote(data)
        },
        getQuoteAllNew: async (params = {}) => {
          const {trm_of_cvr, isrd_vl,coverage_id} = this.filterData
          if (trm_of_cvr == 2 && !isrd_vl) {
            this.$message({
              type: 'warning',
              message: '請填寫投保額'
            })
            return
          }
          let {selectCode,coupon={},code={},is_campaign_code,campaign_code} = this.selectCode||{}
          params.coupon_code = coupon&&coupon.coupon_code
          let quote = this.quoteForm
          if(this.productId==20||this.productId==17&&coverage_id==3)
            quote.bsc_sum_insured = this.bsc_sum_insured
          // if(!this.isFina){
          //
          // }
          params.code = code&&code.code
          if(is_campaign_code==1){
            params.campaign_code =  coupon&&coupon.coupon_code
            params.coupon_code = ''
          }
          params={
            ...params,
            ...this.code_discount_info
          }
          if(this.isFina){
            params.referrer_id=this.referCustomerId
            params.merchant_platform = 2
          }
          const {data} = await getQuoteAllNew({
            ...quote,
            ...this.filterData,
            customer_id:this.customerId||0,
            ...params,
            merchant_platform:this.isFina?2:1
            // code: this.code
          })
          if(!this.isFina)
            this.setReferrerData({
              ...this.code_discount_info
            })
          if (!data.list || data.list.length < 1) {
            this.setAllQuote([])
            this.setQuoteResult({})
          } else {
            this.setAllQuote([])
            this.setQuoteResult({})
            this.setAllQuote(data.list)
            this.setQuoteResult(data)
          }

        },
        getQuoteReference: async (url, params) => {
          const res = await getQuoteReference(url, params)
          downloadFile(res)
        },
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
          let {copy} = this.quoteForm||{}
          // const {pre_fill_referrer_code, referrer_nm, referrer_user_id} = customer_profile
          // let params = {}
          // if(pre_fill_referrer_code){
          //   params.code = {
          //     selectCode: 2,
          //     code: pre_fill_referrer_code,
          //     referrer: referrer_nm,
          //     referrer_user_id
          //   }
          // }
          // this.setSelectCode(params)
          // if(pre_fill_referrer_code){
          //   this.handlerGetAllQuote()
          // }
        },
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .order_select{
    //width: 240px;
  }
  .card-item{
    .flex{
      display: flex;
      justify-content: space-between;
    }
    .flex-inline{
      display: flex;
      div{
        &:first-child{
          .el-button{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        &:last-child{
          .el-button{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }
    .unreset-color{
      color: #409eff;
      cursor: pointer;
    }
    /deep/.el-radio-group{
      .el-radio{
        margin-top: 5px;
      }
    }
  }
  .info-container {
    // display: flex;
    // justify-content: space-between;
    width: calc(100% - 100px);
    // .table {
    //   width: calc(50% - 10px);
    // }
  }

  .quote-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #616266;

    h2 {
      font-size: 24px;
    }

    .left {
      h2 {
        display: inline-block;
        padding-right: 10px;
      }

      span {
        font-size: 16px;
      }
    }

    .right {
      display: flex;
      align-items: center;

      span:first-child {
        display: block;
        padding-right: 10px;
        font-size: 12px;
      }

      & > div {
        margin-right: 10px;
      }
    }
  }

  .main-container {
    display: flex;
    margin-top: 10px;

    .left {
      width: 280px;
      margin-right: 15px;

      .mini {
        color: #91939a;
        font-size: 12px;
        line-height: 14px;
      }
      .card-item{
        width: 280px;
        padding-bottom: 30px;
        .item{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            flex: 1;
            margin: 0;
          }
          .right{
            width: 180px;
            .v-radio-group{
              /deep/.el-radio-group{
                display: flex;
                white-space: nowrap;
                .el-radio-button{
                  flex: 1;
                  .el-radio-button__inner{
                    width: auto;
                    display: block;
                    padding: 6px;
                  }
                }
                .el-radio-button__orig-radio:checked+.el-radio-button__inner{
                  background: #0366D6;
                  border-color: #0366D6;
                }
              }
            }
          }
          & + .item{
            margin-top: 20px;
          }
        }
        & + .card-item{
          padding-top: 30px;
          border-top: 1px solid #D1D5DA;
        }
      }
    }

    .main-content {
      flex: 1;

      .plan-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 15px;
        border-radius: 4px;
        background: white;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .left {
          width: 130px;
          text-align: center;

          .logo {
            display: block;
            margin-top: 10px;
            width: 120px;
            height: 64px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          margin: -15px -15px -15px 0;
          padding-left: 10px;
          width: 140px;
          background: #f4f4f5;

          .span-top {
            position: absolute;
            top: 15px;
            left: 15px;
            display: block;
            padding: 5px 10px;
            border: 1px solid #faecd8;
            border-radius: 4px;
            background: #fdf6ec;
            font-size: 12px;
            color: #e6a23c;
          }

          .amount {
            display: block;
            font-size: 24px;
            font-weight: bold;
            color: #409eff;
          }

          .unit {
            color: #616266;
            font-size: 12px;
          }

          .el-button {
            position: absolute;
            bottom: 15px;
            left: 15px;
          }
        }

        .middle {
          flex: 1;
          position: relative;
          padding-right: 15px;

          .abs-top-right {
            right: 15px;
          }

          .title {
            padding-right: 90px;
            font-size: 20px;
            color: #616266;
            font-weight: bold;
          }

          .flex {
            justify-content: space-between;

            .table {
              flex: 1;

              .table-title {
                font-size: 12px;
                font-weight: bold;
                color: #909399;
              }

              &:first-child {
                margin-right: 15px;

                .tr {
                  span:first-child {
                    width: 115px;
                  }
                }
              }

              &:last-child {
                .tr {
                  span:first-child {
                    width: 130px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  /deep/.coupon-body{
    .align{
      border: 0px!important;
    }
  }
}
</style>
